webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  methods: {}
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Websocket__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bus__ = __webpack_require__(6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'start',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Websocket__["a" /* default */]],
  data: function data() {
    return {
      wss: 'parker2020.daniel@gmail.com',
      token: 'TK9x103qGyD4Tp3AKSSo74J43JTOT0',
      error: '',
      text: '',
      selectedVoice: 0,
      synth: window.speechSynthesis,
      voiceList: [],
      app: 'TextToSpeak',
      greetingSpeech: new window.SpeechSynthesisUtterance()
    };
  },

  created: function created() {
    var lsApp = localStorage.getItem('App');
    if (lsApp) {
      this.app = lsApp;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.voiceList = this.synth.getVoices();

    this.synth.onvoiceschanged = function () {
      _this.voiceList = _this.synth.getVoices();
    };
    var self = this;
    __WEBPACK_IMPORTED_MODULE_1__bus__["a" /* default */].$on('wsMessage', function (payLoad) {
      console.log('payLoad');
      console.log(payLoad);
      if (payLoad.textToSpeak) {
        console.log('textToSpeak');
        self.text = payLoad.textToSpeak;
        self.speak();
      }
    });
    this.speak();
  },
  methods: {
    setApp: function setApp() {
      localStorage.setItem('App', this.app);
      var sendData = { app: this.app };
      this.wsSend(sendData);
    },
    speak: function speak() {
      console.log('speak');
      console.log(this.text);
      this.greetingSpeech.text = '' + this.text;
      console.log(this.synth);
      console.log(this.greetingSpeech);
      if (this.voiceList[2]) {
        this.greetingSpeech.voice = this.voiceList[2];
        this.synth.speak(this.greetingSpeech);
      }
    },
    buttonDescription: function buttonDescription() {
      return this.timerActiv ? 'Clear Timer' : 'Set Timer';
    },
    clickButton: function clickButton() {
      if (!this.timerActiv) {
        var self = this;
        this.timer = setInterval(function () {
          self.pushNotification();
        }, 10000);
      } else {
        clearInterval(this.timer);
      }
      this.timerActiv = !this.timerActiv;
    },
    pushNotification: function pushNotification() {
      if (Notification.permission === 'granted') {
        console.log('PUSH NOTIFICATION');
        navigator.serviceWorker.getRegistration().then(function (reg) {
          if (reg) {
            reg.showNotification('Neuer Termin', {
              body: 'Ein neuer Termin steht an!',
              icon: '../../static/img/icons/android-chrome-192x192.png',
              vibrate: [200, 100, 200, 100, 200, 100, 200],
              tag: 'vibration-sample'
            });
          }
        });
      }
    },
    getTimeMin: function getTimeMin() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
      var yyyy = today.getFullYear();
      // 2020-02-29T00:00:00Z
      return yyyy + '-' + mm + '-' + dd + 'T00:00:00Z';
    },
    getStart: function getStart(item) {
      var d = new Date(item.start.dateTime);
      var dt = d.toLocaleString().replace(',', '').split(' ');
      var date = dt[0].split('.');
      var time = dt[1].split(':');
      return this.weekday[d.getDay()] + ' ' + this.pad_2(date[0]) + '. ' + this.months[date[1]] + ' um ' + time[0] + ':' + time[1] + 'Uhr';
    },
    pad_2: function pad_2(number) {
      return (number < 10 ? '0' : '') + number;
    }
  },
  watch: {
    websocketIsConnected: function websocketIsConnected(newValue) {
      // An websocket mit app anmelden
      if (newValue) {
        console.log('melde mich an');
        var sendData = { app: this.app };
        this.wsSend(sendData);
      }
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export websocketEventName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_config_json__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bus__ = __webpack_require__(6);





var websocketEventName = 'wsMessage';

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      websocketConnection: {},
      websocketInitialized: false,
      websocketIsConnected: false,
      websocketTimerId: 0
    };
  },
  created: function created() {
    this.wsConnect();
  },
  beforeDestroy: function beforeDestroy() {
    window.clearInterval(this.websocketTimerId);
  },

  methods: {
    wsChangeApp: function wsChangeApp(app) {
      this.websocketConnection.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ app: app }));
    },
    wsConnect: function wsConnect() {
      this.wsInit();
      var self = this;
      console.log('try init ws');
      this.websocketTimerId = window.setInterval(function () {
        if (!self.websocketIsConnected) {
          self.wsInit();
        }
      }, __WEBPACK_IMPORTED_MODULE_1__assets_config_json___default.a.websocket.reconnectTimeInterval);
    },
    wsInit: function wsInit() {
      var wssUrl = __WEBPACK_IMPORTED_MODULE_1__assets_config_json___default.a.websocket.connections.prod;
      this.websocketConnection = new WebSocket(wssUrl);

      var self = this;
      this.websocketConnection.onopen = function () {
        console.log('con open');
        self.websocketIsConnected = true;
        window.clearInterval(self.websocketTimerId);
        self.websocketConnection.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          app: self.currentApplication,
          currentUser: self.currentUser,
          initialize: true
        }));
      };

      this.websocketConnection.onclose = function () {
        console.log('ws close');
        if (self.websocketIsConnected) {
          self.websocketIsConnected = false;
          self.wsConnect();
        } else {
          self.websocketIsConnected = false;
        }
      };

      /**
       * deprecated: The EventBus pattern is deprecated! Please use simple Vue child-parent-pattern: $emit!
       */
      this.websocketConnection.onmessage = function (message) {
        return __WEBPACK_IMPORTED_MODULE_2__bus__["a" /* default */].$emit(websocketEventName, JSON.parse(message.data));
      };
      this.websocketInitialized = true;
    },
    wsSend: function wsSend(data) {
      this.websocketConnection.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = (EventBus);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(25);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ebf56b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(14);
function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ebf56b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('header',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19.1,8.7C20.9,10.5 20.9,13.3 19.1,15.2L20.1,16.2C22.6,13.9 22.6,10.1 20.1,7.7L19.1,8.7M18,9.8L17,10.8C17.5,11.5 17.5,12.4 17,13.1L18,14.1C19.2,12.9 19.2,11.1 18,9.8M14,1H4A2,2 0 0,0 2,3V21A2,2 0 0,0 4,23H14A2,2 0 0,0 16,21V3A2,2 0 0,0 14,1M14,20H4V4H14V20Z"}})]),_vm._v(" "),_c('span',[_vm._v("Text to Speak")]),_vm._v(" "),_c('span',{staticClass:"right"})]),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start__ = __webpack_require__(17);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Start',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Start__["a" /* default */]
  }]
}));

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6cdf4c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__(24);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6cdf4c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Websocket_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Websocket_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports) {

module.exports = {"websocket":{"connections":{"prod":"wss://ddns.itjh.de:4040"},"reconnectTimeInterval":30000}}

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.speak($event)}}},[_c('label',{attrs:{"for":"text"}},[_vm._v("Text:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.text),expression:"text"}],staticClass:"form-control",attrs:{"id":"text","type":"text","required":""},domProps:{"value":(_vm.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.text=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"submit"}},[_vm._v("GO")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.setApp($event)}}},[_c('label',{attrs:{"for":"app"}},[_vm._v("WS App:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.app),expression:"app"}],staticClass:"form-control",attrs:{"id":"app","type":"text","required":""},domProps:{"value":(_vm.app)},on:{"input":function($event){if($event.target.composing){ return; }_vm.app=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"submit"}},[_vm._v("GO")])]),_vm._v(" "),(_vm.error.length > 0)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 25 */,
/* 26 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[7]);


// WEBPACK FOOTER //
// static/js/app.68e3ab3d11b0c46f73a2.js